module.exports = __webpack_public_path__ + "static/img/card_decoration.e150764f.png";